
import { supabase } from "@/integrations/supabase/client";
import type { WinnerData, Prize } from "./types/winner";

export async function createWinner(data: WinnerData): Promise<{ prize: Prize | null }> {
  try {
    console.log('Creating winner entry with data:', data);
    
    // Get active university
    const { data: universities, error: universityError } = await supabase
      .from('universities')
      .select('id')
      .eq('is_active', true)
      .single();

    if (universityError) {
      console.error('Error fetching active university:', universityError);
      throw universityError;
    }

    // First try to increment the allocation
    const { data: incrementResult, error: incrementError } = await supabase
      .rpc('increment_prize_allocation', {
        prize_id_param: data.prize_id,
        university_id_param: universities.id
      });

    if (incrementError) {
      console.error('Error incrementing allocation:', incrementError);
      throw incrementError;
    }

    if (!incrementResult) {
      console.log('Prize allocation limit reached');
      return { prize: null };
    }

    // Only create winner entry if allocation was successful
    const winnerData = {
      prize_id: data.prize_id,
      tip_id: data.tip_id,
      claimed: false,
      device_info: {
        ...data.device_info,
        timestamp: new Date().toISOString()
      },
      source: data.source || 'unknown',
      vote_content: data.vote_content,
      university_id: universities.id
    };

    const { error: winnerError } = await supabase
      .from('winners')
      .insert([winnerData]);

    if (winnerError) {
      console.error('Error creating winner entry:', winnerError);
      // If winner creation fails, we should log it but continue
      // since the allocation has already been made
      console.warn('Winner creation failed but allocation was made');
    }

    // Get prize details
    const { data: prizeData, error: prizeError } = await supabase
      .from('prizes')
      .select('*')
      .eq('id', data.prize_id)
      .single();

    if (prizeError) {
      console.error('Error fetching prize details:', prizeError);
      throw prizeError;
    }

    return { prize: prizeData };
  } catch (error) {
    console.error('Error in createWinner:', error);
    throw error;
  }
}

export { selectPrize } from './prizeSelection';
